<div *ngIf="scheduling_method == 'PARTICULAR'" class="conteiner">
  <h2 mat-dialog-title>Mudança de método de agendamento - {{ encounter.name }}</h2>
  <div>
    <page-alert *ngIf="showSuccessMessage" message="Salvo com sucesso!" alertClass="alert-success"></page-alert>
    <page-alert *ngIf="showErrorMessage && !showSuccessMessage" message="Falha ao realizar operação!" alertClass="alert-danger"></page-alert>
  </div>
  <div>
    <p>Seu método de agendamento atual é: Particular, caso queira mudar para Convênio, preencha os dados abaixo:</p>

    <div class="row">
      <div class="col-md-3" style="margin-top: 5px">
        <mat-form-field class="example-full-width" appearance="outline" style="margin-top: 15px">
          <mat-label>Tipo de Agendamento</mat-label>
          <mat-select [(ngModel)]="encounter.scheduling_method">
            <mat-option selected value="CONVENIO">Convênio</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-md-3">
        <mat-form-field class="example-full-width" appearance="outline">
          <mat-label>Plano de Saúde</mat-label>
          <mat-select
            [(ngModel)]="encounter.health_plan.health_plan_name"
            (ngModelChange)="setHealthPlanAgreements(encounter.health_plan.health_plan_name)"
          >
            <mat-option *ngFor="let plan of healthPlansOrganization" [value]="plan.name">{{ plan.name }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-md-3">
        <mat-form-field class="example-full-width" appearance="outline">
          <mat-label>Modalidade:</mat-label>
          <mat-select [(ngModel)]="encounter.health_plan.agreement">
            <mat-option *ngFor="let agreement of this.healPlanAgreement" [value]="agreement.name">{{ agreement.name }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-md-3">
        <mat-form-field class="example-full-width" appearance="outline">
          <mat-label>Número da Carteira</mat-label>
          <input [(ngModel)]="encounter.health_plan.card_number" mask="0 000 0000000000000" matInput />
        </mat-form-field>
      </div>
    </div>
  </div>
</div>

<div *ngIf="scheduling_method == 'CONVENIO'" class="conteiner">
  <h2 mat-dialog-title>Mudança de método de agendamento - {{ encounter.name }}</h2>
  <div>
    <page-alert *ngIf="showSuccessMessage" message="Salvo com sucesso!" alertClass="alert-success"></page-alert>
    <page-alert *ngIf="showErrorMessage && !showSuccessMessage" message="Falha ao realizar operação!" alertClass="alert-danger"></page-alert>
  </div>
  <div>
    <p>Seu método de agendamento atual é: Convênio, caso queira mudar para Particular, preencha os dados abaixo:</p>

    <div class="row">
      <div class="col-md-3" style="margin-top: 5px">
        <mat-form-field class="example-full-width" appearance="outline" style="margin-top: 15px">
          <mat-label>Tipo de Agendamento</mat-label>
          <mat-select [(ngModel)]="encounter.scheduling_method">
            <mat-option selected value="PARTICULAR">Particular</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="example-full-width" appearance="outline" style="margin-top: 15px">
          <mat-label>Forma de Pagamento</mat-label>
          <mat-select [(ngModel)]="encounter.paymentMethod">
            <mat-option value="PIX">PIX</mat-option>
            <mat-option value="CREDIT_CARD">Cartão de Crédito</mat-option>
            <mat-option value="PHYSICAL">Fisicamente</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>
</div>

<mat-dialog-actions align="end">
  <button mat-button color="primary" [mat-dialog-close]="false">Fechar</button>
  <button mat-flat-button color="primary" (click)="save()" [disabled]="!isFormValid()">Salvar</button>
</mat-dialog-actions>
